import SnackbarAlert from './snackbar-alert';

export default SnackbarAlert;
